import(/* webpackMode: "eager", webpackExports: ["TermlyPolicy","TermsAndConditionsPolicyDataId"] */ "/codebuild/output/src883433070/src/apps/wrap.gifts/src/services/Termly/TermlyPolicy.tsx");
